module.exports = __webpack_public_path__ + "img/icon_close-x.3123a592.svg";